export enum ScriptLoadState {
  FAILED = 0,
  INACTIVE = 1,
  PENDING = 2,
  SUCCESS = 3,
}

export const newScript = (src: string, key: string, cb: (loadState: ScriptLoadState) => void) => {
  const firstJS = document.getElementsByTagName('script')[0];
  const scriptElem: HTMLScriptElement = document.createElement('script');
  scriptElem.src = src;
  scriptElem.id = key;
  scriptElem.addEventListener('load', () => {
    cb(ScriptLoadState.SUCCESS);
  });
  scriptElem.addEventListener('error', () => {
    cb(ScriptLoadState.FAILED);
  });

  (firstJS.parentNode as HTMLElement).insertBefore(scriptElem, firstJS);
};
